<template>
  <div class="account-admin container">
    <div class="row mb-2">
      <div class="col-12 col-md-3">
        <h1>
          Sessions
        </h1>
      </div>
      <div class="col-12 col-md-9 text-right">
        <form-component>
          <div class="form-row">
            <div class="col-12 col-md-6" />
            <div class="col-12 col-md-6">
              <input-select
                id="filter"
                v-model="filter"
                :value="filter"
                name="filter"
                label="Report"
                type="select"
                :options="filterOptions"
                @input="pickReport"
              />
            </div>
          </div>
        </form-component>
      </div>
      <div class="col-12">
        <hr />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="dashboard-card">
          <outcomes-report v-if="filter === 'outcomes'" />
          <upcoming-sessions-report v-else-if="filter === 'upcoming'" />
          <ongoing-sessions-report v-else-if="filter === 'ongoing'" />
          <request-report v-else-if="filter === 'requested'" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormComponent from '@/components/FormComponent.vue';
import UpcomingSessionsReport from './components/UpcomingSessionsReport.vue';
import InputSelect from '../../components/inputs/InputSelect.vue';
import RequestReport from './components/RequestReport.vue';
import OutcomesReport from './components/OutcomesReport.vue';
import OngoingSessionsReport from './components/OngoingSessionsReport.vue';

export default {
  name: 'SuperAdminAppointments',
  components: {
    FormComponent,
    OutcomesReport,
    InputSelect,
    UpcomingSessionsReport,
    RequestReport,
    OngoingSessionsReport,
  },
  data() {
    return {
      filter: null,
      filterOptions:[
        { id: 'ongoing', display_label: 'Ongoing' },
        { id: 'upcoming', display_label: 'Upcoming' },
        { id: 'outcomes', display_label: 'Outcomes' },
        { id: 'requested', display_label: 'Requested' },
      ]
    };
  },
  mounted() {
    const { report } = this.$route.query;
    const option = this.filterOptions.find(x => x.id === report);
    if (option) { this.filter = option.id; } else { this.filter = this.filterOptions[0].id; }
  },
  methods:{
    async pickReport(report) {
      this.filter = report;
      await this.$router.replace({
        name: this.$route.name,
        query: { ...this.$route.query, report }
})
    }
  },
}
</script>

<style lang="scss" scoped>
.account-admin {
  h1 {
    margin-top: 20px;

    @media (max-width: $md-max) {
      margin-top: 0;
      margin-bottom: 40px;
    }
  }

  .fullWidth {
    width: 100%;
    margin: 5px;
  }

  ::v-deep .btn-group {
    margin-top: 8px;

    @media (max-width: $sm-max) {
      width: 100%;
    }

    .btn {
      @include border-radius($border-radius !important);

      background: rgba(255, 255, 255, 0.25) !important;
      color: white !important;
      margin-right: 5px;
      font-weight: normal;
      outline: 0 !important;
      box-shadow: none !important;

      @media (min-width: $xl-min) {
        min-width: 120px;
      }

      &.last {
        margin-right: 0;
      }

      &.active {
        background-color: white !important;
        color: rgba(0, 0, 0, 0.76) !important;
      }

      @media (max-width: $sm-max) {
        width: 25%;
      }
    }
  }
}
</style>
